import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  reportData: null,
  units: [],
  loading: false,
  exportLoading: false,
  pdfExportLoading: false,
  error: null,
  successMessage: null,
  // Filters
  filterUnitId: '',
  filterFromDate: '',
  filterToDate: '',
};

const accessReportSlice = createSlice({
  name: 'accessReport',
  initialState,
  reducers: {
    // Fetch init data (units)
    fetchInit: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchInitSuccess: (state, action) => {
      state.loading = false;
      state.units = action.payload.units || [];
      state.error = null;
    },
    fetchInitFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch access report
    fetchAccessReport: (state) => {
      state.loading = true;
      state.error = null;
      state.reportData = null; // Clear old data before fetching new data
    },
    fetchAccessReportSuccess: (state, action) => {
      state.loading = false;
      state.reportData = action.payload;
      state.error = null;
    },
    fetchAccessReportFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Filters
    setFilterUnitId: (state, action) => {
      state.filterUnitId = action.payload;
    },
    setFilterFromDate: (state, action) => {
      state.filterFromDate = action.payload;
    },
    setFilterToDate: (state, action) => {
      state.filterToDate = action.payload;
    },

    // Clear filters
    clearFilters: (state) => {
      state.filterUnitId = '';
      state.filterFromDate = '';
      state.filterToDate = '';
      state.reportData = null;
    },

    // Export to Excel
    exportAccessReportToExcel: (state) => {
      state.exportLoading = true;
      state.error = null;
    },
    exportAccessReportToExcelSuccess: (state, action) => {
      state.exportLoading = false;
      state.successMessage = action.payload;
      state.error = null;
    },
    exportAccessReportToExcelFailure: (state, action) => {
      state.exportLoading = false;
      state.error = action.payload;
    },

    // Export to PDF
    exportAccessReportToPdf: (state) => {
      state.pdfExportLoading = true;
      state.error = null;
    },
    exportAccessReportToPdfSuccess: (state, action) => {
      state.pdfExportLoading = false;
      state.successMessage = action.payload;
      state.error = null;
    },
    exportAccessReportToPdfFailure: (state, action) => {
      state.pdfExportLoading = false;
      state.error = action.payload;
    },

    // Clear messages
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
});

export const {
  fetchInit,
  fetchInitSuccess,
  fetchInitFailure,
  fetchAccessReport,
  fetchAccessReportSuccess,
  fetchAccessReportFailure,
  exportAccessReportToExcel,
  exportAccessReportToExcelSuccess,
  exportAccessReportToExcelFailure,
  exportAccessReportToPdf,
  exportAccessReportToPdfSuccess,
  exportAccessReportToPdfFailure,
  setFilterUnitId,
  setFilterFromDate,
  setFilterToDate,
  clearFilters,
  clearError,
  clearSuccessMessage,
} = accessReportSlice.actions;

// Selectors
export const selectAccessReportData = (state) => state.accessReport?.reportData;
export const selectAccessReportUnits = (state) => state.accessReport?.units || [];
export const selectAccessReportLoading = (state) => state.accessReport?.loading || false;
export const selectAccessReportExportLoading = (state) => state.accessReport?.exportLoading || false;
export const selectAccessReportPdfExportLoading = (state) => state.accessReport?.pdfExportLoading || false;
export const selectAccessReportError = (state) => state.accessReport?.error;
export const selectAccessReportSuccessMessage = (state) => state.accessReport?.successMessage;
export const selectAccessReportFilterUnitId = (state) => state.accessReport?.filterUnitId ?? '';
export const selectAccessReportFilterFromDate = (state) => state.accessReport?.filterFromDate || '';
export const selectAccessReportFilterToDate = (state) => state.accessReport?.filterToDate || '';

export default accessReportSlice.reducer;
